<template>
  <el-dialog v-model="dialogStatus" :close-on-click-modal="false" @close="close" :title="dialogTitle" :width="width"
    append-to-body>

    <el-form :model="form" :rules="rules" hide-required-asterisk ref="form" >
      <el-form-item prop="price">
        <template v-slot:label>
          <div class="form-item__label">输入{{type}}低价（单位：分）<span style="color: #ed5b4e;">{{form.price/100}} ：ecpm</span></div>
        </template>
        <div>
          <el-input v-model="form.price"  type="number" style="width:160px;margin-right: 10px;"
            placeholder="" />
        </div>
        <div style="color:red">注释：输入0则为取消配置</div>
      </el-form-item>
    </el-form>

    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateApplicationOut, updateApplicationIn } from '@/api/manage/keyword/appReport'
import { appTypeList } from '@/const/app-type'
import SearchChannelSelect from '@/components/SearchChannelSelect'

const form = {
  appBundle: undefined,
  keyword: undefined,
  price: ''
}
export default {
  components: {
    SearchChannelSelect
  },
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  inject: ['init'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,

      form: Object.assign({}, form),
      type: '',
      rules: {
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      },
      appTypeList: appTypeList
    }
  },
  created () { },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.appBundle ? '编辑' : '新增')
    }
  },
  methods: {
    show (data, type) {
      this.dialogStatus = true
      this.type = type === 'expend' ? '支出' : '收入'

      const datas = {
        appBundle: data.appBundle,
        keyword: data.keyword
      }
      if (datas) {
        this.form = Object.assign({}, datas)
      }
      this.$nextTick(() => {
        if (this.type === '支出') {
          this.form.price = data.outLowPrice || 0
        } else if (this.type === '收入') {
          this.form.price = data.inLowPrice || 0
        }
      })
    },
    close () {
      this.dialogStatus = false
      // this.reset()
    },
    submit () {
      this.submitLoading = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.price < 0) {
            this.$message.error('价格不能为负')
            this.submitLoading = false
            return
          }
          if (this.type === '支出') {
            updateApplicationOut(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success('配置成功')
                this.close()
                this.init()
                this.submitLoading = false
              }
            }).finally(() => {
              this.dialogStatus = false
            })
          } else if (this.type === '收入') {
            updateApplicationIn(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success('配置成功')
                this.close()
                this.init()
                this.submitLoading = false
              }
            }).finally(() => {
              this.dialogStatus = false
            })
          }
        }
      })
    },
    add (form) {
      this.submitLoading = true
      // addAdChannelApp(form).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success('新增成功')
      //     this.$emit('submit')
      //     this.close()
      //   }
      // }).finally(() => {
      //   this.submitLoading = false
      // })
    },
    update (form) {
      this.submitLoading = true
      // updateAdChannelApp(form).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success('编辑成功')
      //     this.$emit('submit')
      //     this.close()
      //   }
      // }).finally(() => {
      //   this.submitLoading = false
      // })
    },
    reset () {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

.el-form-item {
  display: block;
}

.el-form-item ::v-deep .el-form-item__label {
  display: inline-block;
}
</style>
